




import Vue from 'vue';
import { mapState } from 'vuex';
export default Vue.extend({
    props: {
        size: {
            type: Number,
            default: 128,
        },
    },
    computed: {
        ...mapState(['instanceId']),
        imgUrl() {
            return `${process.env.VUE_APP_BASE_API_URL}static/${this.instanceId}/portal_logo`;
        },
    },
});
